export default {
	saveApprReason: SAVE_APPR_REASON_POPUP()
};
function SAVE_APPR_REASON_POPUP() {
	return {
		title: '', //팝업타이틀
		btnMsg: '', //버튼명
		labelMsg: '', //라벨명
		contents: '', //내용
		apprState: '', //결재상태코드 20: 기각. 30:반려
		apiType: '', //업무구분값
		masterKey1: '', //마스터키(예를들어서 문서키 PWA신청현황에서는 PWA번호가 키입니다.)
		masterKey2: '', //마스터키(예를들어서 문서키 PWA신청현황에서는 PWA번호가 키입니다.)
		masterKey3: '', //마스터키(예를들어서 문서키 PWA신청현황에서는 PWA번호가 키입니다.)
		masterKey4: '', //마스터키(예를들어서 문서키 PWA신청현황에서는 PWA번호가 키입니다.)
		masterKey5: '' //마스터키(예를들어서 문서키 PWA신청현황에서는 PWA번호가 키입니다.)
	};
}

export { SAVE_APPR_REASON_POPUP };
